module.exports = __webpack_public_path__ + "static/mr-concert-performance-14-7a839c2891c0fbd775268c1a971b0d8b.jpg";